export default __webpack_public_path__ + "static/media/switcher-enable.fd2ec09e.svg";